/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Item/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import DataVaxiomEmployeeProfessionalsRelationshipsItem from 'DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/index'
import DataVaxiomOtherProfessionalsRelationshipsItem from 'DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Item({
  children,
  viewPath = "/DesignSystem/DataVaxiomProfessionalsRelationshipsList/Content/Item"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let professionalDtypeValueData = fromData.useDataFormat({ viewPath,
context: 'professional',
path: 'dtype',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: professionalDtypeValueData,
})
let professionalValueData = fromData.useDataValue({ viewPath,
context: 'professional',
})
let professionalValueData1 = fromData.useDataValue({ viewPath,
context: 'professional',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DataVaxiomEmployeeProfessionalsRelationshipsItem'}>
<DataVaxiomEmployeeProfessionalsRelationshipsItem
  viewPath={`${viewPath}/DataVaxiomEmployeeProfessionalsRelationshipsItem`}
 data="professional"
 value={professionalValueData}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DataVaxiomOtherProfessionalsRelationshipsItem'}>
<DataVaxiomOtherProfessionalsRelationshipsItem
  viewPath={`${viewPath}/DataVaxiomOtherProfessionalsRelationshipsItem`}
 data="professional"
 value={professionalValueData1}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}